import {
    ADMINGETBANK_SUCCESS,
    ADMINGETBANK_FAILED,
    RESET_ADMINGETBANK,
    LOADING_ADMINGETBANK,
    NETWORK_ERROR_ADMINGETBANK
} from "../types/index";
import { adminServices } from "../../config/axios";


const resetAdminGetBANK = () => {
    return { type: RESET_ADMINGETBANK };
};

const AdminGetBankList = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_ADMINGETBANK });
    await adminServices
        .post("getBankList", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(AdminGetListsuccess(res.data));
                    break;
                default:
                    dispatch(AdminGetListFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_ADMINGETBANK,
                payload: err
            });
        });
};


function AdminGetListsuccess(data) {
    return {
        type: ADMINGETBANK_SUCCESS,
        payload: data
    };
}
function AdminGetListFailed(data) {
    return {
        type: ADMINGETBANK_FAILED,
        payload: data
    };
}

export { AdminGetBankList, resetAdminGetBANK }